<div *ngIf="patient" class="patient-summary mb-4">

    <div class="d-flex flex-wrap align-items-center gap-4">

        <div>

            <i class="fa-solid fa-user text-primary-custom me-2"></i>

            <strong>

                {{ patient.cognome }}
                {{ patient.nome }}

            </strong>

        </div>

        <div>

            <i class="fa-solid fa-id-badge text-primary-custom me-2"></i>

            Id
            <strong>

                {{ patient.idPaziente }}

            </strong>

        </div>

        <div>

            <i class="fa-solid fa-id-card text-primary-custom me-2"></i>

            <span class="badge bg-secondary">

                {{ patient.codice }}

            </span>

        </div>

        <div>

            <i class="fa-solid fa-cake-candles text-primary-custom me-2"></i>

            {{ patient.dataNascita | date:'dd/MM/yyyy' }}

        </div>

        <div>

            <i class="fa-solid fa-hourglass-half text-primary-custom me-2"></i>

            {{ utilitiesHelper.calculateAge(patient.dataNascita) }}
            anni

        </div>

        <div>

            <i class="fa-solid me-2" [class.fa-mars]="patient.genere === 'M'" [class.fa-venus]="patient.genere === 'F'"
                [class.gender-male]="patient.genere === 'M'" [class.gender-female]="patient.genere === 'F'">

            </i>

            {{ patient.genere === 'M'
            ? 'Maschio'
            : 'Femmina' }}

        </div>

        <span class="badge ms-2 bg-primary-custom" style="cursor:pointer" title="Apri scheda paziente"
            (click)="goToPatient()">

            <i class="fa-solid fa-notes-medical me-1">

            </i>

            {{
            accessiCount === 1
            ? '1 accesso'
            : accessiCount + ' accessi'
            }}

        </span>

        <span *ngIf="lastSfge" class="badge ms-2" [ngClass]="sfgeHelper.getClasseRischioColor(lastSfge.classeRischio)" title="Classe di rischio SFGE">
            <i class="fa-solid fa-clipboard-check me-1"></i>
            {{ lastSfge.classeRischio }}
        </span>

    </div>

</div>